<div
	#stackedVerticalBarChartContainer
	class="stacked-vertical-bar-chart-container"
	[style.height.px]="getChartDimensions()[1]"
	[style.width.px]="getChartDimensions()[0]"
>
	<div #stackedVerticalBarChart class="stacked-vertical-bar-chart-canvas"></div>
</div>
